import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
const FooterIntro = () => {
  const [state] = useState({
    logo: "/assets/footer/gtl_logo.png",
    intro:
      "Global Talia Limited is a household name in the Construction industry which was founded by budded professionals to give quality construction outputs and values. Its vision is driven by professionals with clear goals and ability to deliver and achieve projects with respect to standards, quality, cost and time.",
  });
  return (
    <div className="footer__intro">
      <div className="footer__intro__img animation">
        <LazyLoadImage src={state.logo} alt="footer logo" />
      </div>
      <p className="footer__intro__msg animation">{state.intro}</p>
    </div>
  );
};
export default FooterIntro;
